import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { FilterResource } from '../../services/resources/filter.resource';
import { FilterModalComponent } from './modal/filter-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ContentService } from '../../services/content/content.service';

const content = require('./filter.content.json');

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnDestroy {
  @Input()
  public mode: string = 'functie';

  @Input()
  public subset?: string;

  @Input()
  public total: number;

  @Input()
  public previewTotal: number;

  @Input()
  public filterState: any;

  public rawFilters: any;
  public filterModalSubscription: Subscription;
  public options: any;
  private subscriptions: Subscription[] = [];

  @Output()
  public filterStateChange: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public filtersLoaded: EventEmitter<any> = new EventEmitter<any>();

  public constructor(
    private filterResource: FilterResource,
    private matDialog: MatDialog,
    private contentService: ContentService
  ) {
    this.contentService.loadContent(content);
  }

  public ngOnInit(): void {
    this.subscriptions.push(this.filterResource.getFilters(this.mode, this.subset).subscribe((rawFilters: any) => {
      this.rawFilters = rawFilters;
      this.initializeFiltersWithDefaultValue();
      this.filtersLoaded.emit(rawFilters);
    }));
  }

  public ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initializeFiltersWithDefaultValue(): void {
    this.rawFilters.forEach(filter => {
      filter.optieSets.forEach(optionSet => {
        optionSet.opties = optionSet.opties.map(item => {
          return {
            value: item,
            checked: false
          };
        });
      });
    });
  }

  public openFilterModal(): void {
    const ref: any = this.matDialog.open(FilterModalComponent, {
      height: '100%',
      width: '100%',
      maxHeight: '100%',
      maxWidth: '100%'
    });
    ref.componentInstance.setFilters(this.rawFilters);
    ref.componentInstance.ref = ref;
    ref.componentInstance.total = this.total;
    ref.componentInstance.previewTotal = this.previewTotal;
    ref.componentInstance.mode = this.mode;
    if (this.filterState) {
      ref.componentInstance.parseOptions(this.filterState);
    }
    this.filterModalSubscription = ref.afterClosed().subscribe(results => this.handleFilterModalResponse(results));
  }

  public handleFilterModalResponse(results: any): void {
    if (!results) {
      return;
    }
    this.filterStateChange.emit(results);
    this.filterModalSubscription.unsubscribe();
  }
}
